export function formatPhoneNumber(phoneNumber: string): string {
  // Remove o sufixo @c.us se existir
  const cleanNumber = phoneNumber.replace('@c.us', '');

  // Remove todos os caracteres não numéricos
  const numbersOnly = cleanNumber.replace(/\D/g, '');

  // Verifica se o número começa com 55 (Brasil)
  if (numbersOnly.startsWith('55')) {
    // Formata o número no padrão brasileiro: (XX) XXXXX-XXXX
    const ddd = numbersOnly.slice(2, 4);
    const firstPart = numbersOnly.slice(4, 8);
    const secondPart = numbersOnly.slice(8);

    return `(${ddd}) ${firstPart}-${secondPart}`;
  }

  // Se não for um número brasileiro, retorna o número limpo
  return numbersOnly;
}
